// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "RESUMEN DEL AÑO",
    "note": "* Todas las estadísticas en este resumen son hasta 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nJugaste KKPoker por primera vez en 2025."
  },
  "report": {
    "loginTime": "Desde ese día,\nKKPoker te acompañó a lo largo de \n{loginDay}",
    "loginTips": "* Días que iniciaste sesión en KKPoker en 2025.",
    "enjoyTime": "¡Las\n{loginTime}\nes el momento más divertido del día para ti! ¡Este es tu horario favorito para abrir KKPoker!",
    "firstHandDate": "El\n{first_hand_date}\nrecibiste tu primera mano del año jugando en {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "Este año en KKPoker, jugaste un total de\n{hands}\nTu amor por el poker superó al \n{percentage} de los jugadores.",
    "v2": "Este año en KKPoker, jugaste un total de\n{hands}\n¡Gracias por acompañarnos en esta aventura!",
    "v3": "Este año en KKPoker, jugaste un total de \n{hands}\nKKPoker se esforzará por mejorar y ofrecerte una experiencia aún más divertida el próximo año."
  },
  "hardTime": {
    "date": "{one_day_hands}\nEste fue tu día de mayor dedicación en KKPoker.",
    "hands": "Ese día jugaste un total de\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "De tu número total de manos,\n{handsNum} {hands} fueron en tu formato de juego favorito, {game}",
  "kkWin": {
    "v1": "En 2025, obtuviste KK un total de\n{all} {longTimes}\ny derrotaste a tus oponentes con KK\n{win} {longTimesTwo}",
    "v2": "Este año, fuiste all-in\n{all} {threeTimes}\nTu porcentaje de victorias con all-in:\n{percentage}\n¡El poker es un juego para valientes!"
  },
  "achievement": {
    "spinup": "¡El {spinup_date}\nfue tu día más afortunado!",
    "spinup_2": "Ese día, \nobtuviste el multiplicador {spinup_ratio} en SpinUp y ganaste\n{spinup_reward}",
    "mtt": "{mtt_date}\nfue lo mejor de tu año.",
    "mtt_2": "Ese día,\nalcanzaste el puesto {no} {mtt_rank} en {mtt_name}\ny ganaste\n{mtt_reward}",
    "rg": "{rg_date}\n¡Un día destacado en tu aventura de póker!",
    "rg_2": "Ese día, ganaste el mayor pozo del año:\n{rg_reward}"
  },
  "lucky": {
    "title": "Cada mano cuenta\nuna historia diferente",
    "luckyHand": "MANO \nDE LA SUERTE",
    "unLuckyHand": "MANO \nDE LA MALA SUERTE",
    "luckyRate": "Porcentaje de victorias:\n{lucky_rate}",
    "unLuckyRate": "Porcentaje de victorias\n{unlucky_rate}",
    "luckyText": "{lucky_hand} fue tu mano estrella.\n¡Ganaste el {lucky_rate} de las veces cuando la tuviste!",
    "unLuckyText": "¡Cuidado con {unlucky_hand}…\nSolo ganaste el {unlucky_rate} de las veces con ella.",
    "note": "*Solo las manos iniciales repartidas 10 veces o más son elegibles."
  },
  "futureStory": "¡KKPoker está ansioso por seguir escribiendo contigo la historia de tu aventura en el poker en 2026!",
  "version3": {
    "text": "Lamentablemente, no dejaste ningún recuerdo con KKPoker en 2025.",
    "continue": "¡Ven a escribir el próximo capítulo\nde tu aventura en KKPoker en 2026!",
    "tips": "* Todas las estadísticas son hasta el 2024-12-31."
  },
  "button": {
    "save": "Guardar imagen",
    "copy": "Copiar y compartir"
  },
  "unit": {
    "days": "días",
    "hands": "manos",
    "longHands": "manos",
    "longTimes": "veces",
    "longTimesTwo": "veces",
    "threeTimes": "veces",
    "times": "veces",
    "multiplier": "multiplicador ",
    "num": "N.º ",
    "num2": "",
    "bets": "apuestas",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "Enlace copiado",
    "imageSaved": "Imagen guardada"
  }
}
  